<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="onConfirm"
  >
    <v-card-text class="mt-2">
      <v-row>
        <v-col>
          <v-text-field
            label="Orsak"
            outlined
            v-model="model.name"
            :rules="[required]"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer />
      <v-btn rounded @click="closeModal">Avbryt</v-btn>
      <v-btn rounded type="submit" color="primary" :loading="pending"
        >Skapa</v-btn
      >
    </v-card-actions>
  </v-form>
</template>

<script>
import { required } from '@/common/validationRules'
import * as uuid from 'uuid/v4'
import gql from 'graphql-tag'

export default {
  name: 'MasterdataReasonsCreateModal',

  props: {
    refetch: Function
  },

  data: () => ({
    required,
    valid: true,
    pending: false,

    model: {
      uuid: uuid(),
      name: ''
    }
  }),

  methods: {
    async onConfirm() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return

      this.pending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: CreateReasonInput!) {
            createReason(payload: $payload) {
              reason_uuid
            }
          }
        `,
        variables: {
          payload: this.model
        }
      })

      this.pending = false
      this.refetch()
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
    }
  }
}
</script>
